var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPause10 = function SvgIconPause10(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 71 69"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2B328C",
    d: "M63.969 13.666 35.5 0 7.031 13.666 0 44.374 19.701 69h31.598L71 44.374z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#999DC8",
    d: "M37.205 41.999H41V31h-3.795v10.999zM30 42h3.795V31.001H30V42z"
  }))));
};
export default SvgIconPause10;